import { render, staticRenderFns } from "./Infos.vue?vue&type=template&id=eadd4da8&scoped=true&"
import script from "./Infos.vue?vue&type=script&lang=js&"
export * from "./Infos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eadd4da8",
  null
  
)

export default component.exports